import React, { useEffect, useState } from 'react';
import API from 'api';
const Picture = ({
  src,
  size = '',
  w = null,
  h = null,
  crop = false,
  fit = 'cover',
  width = '',
  height = '',
  className = '',
  style = {},
  onLoaded = null,
}) => {
  const [file, setFile] = useState({ contents: '' });

  useEffect(() => {
    if (src) {
      getContents();
    }
  }, [src, w, h, crop, fit]);

  const getContents = async () => {
    try {
      let url = '';

      if (w || h) {
        url =
          `/utils/image?path=${src}` +
          (w ? `&w=${w}` : '') +
          (h ? `&h=${h}` : '') +
          (crop ? `&crop=1` : '') +
          (fit ? `&fit=${fit}` : '');
      } else {
        url =
          `/utils/file?path=${src}` +
          (size !== '' ? `&size=${size}` : '');
      }

      API.handleError = false;
      const response = await API.get(url);
      setFile(response.data);

      if (onLoaded) {
        onLoaded(response.data.name);
      }
    } catch (error) {
      setFile({
        contents:
          'PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmci...',
        mimetype: 'image/svg+xml',
      });
    }
  };

  return (
    <>
      {file.contents && (
        <img
          src={`data:${file.mimetype};base64,${file.contents}`}
          alt=""
          className={className}
          style={{
            width: width ? `${width}px` : undefined,
            height: height ? `${height}px` : undefined,
            ...style,
          }}
        />
      )}
    </>
  );
};
export default Picture;